//load tinymce editor plugins
window.tinymce = require("tinymce");
//tinymce configuration
tinymce.baseURL = "/js/tinymce";
tinymce.baseURI = new tinymce.util.URI(tinymce.baseURL);
tinymce.init({
    selector: ".tiny_editor",
    // height: 300,
    menubar: false,
    paste_as_text: true,
    valid_elements:
        "strong/b,div[align],br,i,ul,ol,li,p,table,tbody,thead,tr,td,textformat[blockindent|indent|leading|leftmargin|rightmargin|tabstops],u",
    invalid_elements: "a[href|target=_blank],img,form",
    // plugins: [
    // 	'advlist autolink lists link image charmap print preview anchor textcolor searchreplace visualblocks code fullscreen insertdatetime media table contextmenu paste code help wordcount'
    // ],
    toolbar:
        "undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent",
});
